module.exports = __webpack_public_path__ + "img/hviezda4.136218bd.svg";